/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportsresolved2Inputs */

const en_contentreportsresolved2 = /** @type {(inputs: Contentreportsresolved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolved`)
};

const de_contentreportsresolved2 = /** @type {(inputs: Contentreportsresolved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigt`)
};

/**
* | output |
* | --- |
* | "Resolved" |
*
* @param {Contentreportsresolved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportsresolved2 = /** @type {((inputs?: Contentreportsresolved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportsresolved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportsresolved2(inputs)
	return de_contentreportsresolved2(inputs)
});
export { contentreportsresolved2 as "contentReportsResolved" }